// extracted by mini-css-extract-plugin
export default {"modalOverlay":"PQ-z","modalContent":"QQ-z","header":"RQ-z","close":"SQ-z"};